'use client';
import Link from 'next/link';
import { useState } from 'react';
import FeatureRequestModal from '@/app/components/FeatureRequestModal';

export default function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [showFeatureRequest, setShowFeatureRequest] = useState(false);

  return (
    <>
      <footer style={{
        borderTop: '1px solid var(--border)',
        background: 'var(--surface)',
        marginTop: '60px',
        padding: '24px 20px',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{
          maxWidth: '768px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
        }}>

          {/* Brand + copyright */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ fontSize: '13px', color: 'var(--text-dim)', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>🌿</span>
              <span style={{ fontFamily: 'Instrument Serif, serif' }}>NoiseGate™</span>
              <span style={{ color: 'var(--text-dim)' }}>·</span>
              <span>Reduce the noise.</span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-dim)' }}>
              © 2026 NoiseGate, LLC. All rights reserved.
            </div>
          </div>

          {/* Links */}
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
            <a
              href="https://instagram.com/noisegate_insta"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="NoiseGate on Instagram"
              style={{ display: 'flex', alignItems: 'center', color: 'var(--text-dim)' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor"/>
              </svg>
            </a>
            <a
              href="https://x.com/noisegate_x"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="NoiseGate on X"
              style={{ display: 'flex', alignItems: 'center', color: 'var(--text-dim)' }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.94l-5.43-7.11L3.9 22H.64l8.03-9.18L1 2h7.1l4.9 6.5L18.244 2Zm-1.216 18h1.92L7.06 4h-1.98l11.95 16Z" fill="currentColor"/>
              </svg>
            </a>
            <Link href="/privacy#data-sharing" style={{
              fontSize: '12px', color: 'var(--text-dim)', textDecoration: 'none',
            }}>
              Do Not Sell My Info
            </Link>
            <button
              onClick={() => setShowFeatureRequest(true)}
              style={{
                fontSize: '12px', color: 'var(--text-dim)', background: 'none',
                border: 'none', cursor: 'pointer', padding: 0,
                fontFamily: 'DM Sans, sans-serif',
              }}
            >
              Suggest a feature
            </button>
            <button
              onClick={() => setShowContact(true)}
              style={{
                fontSize: '12px', color: 'var(--text-dim)', background: 'none',
                border: 'none', cursor: 'pointer', padding: 0,
                fontFamily: 'DM Sans, sans-serif',
              }}
            >
              Contact
            </button>
          </div>

        </div>
      </footer>

      {/* Contact modal */}
      {showContact && (
        <div
          onClick={() => setShowContact(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 100,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius)',
              padding: '28px',
              maxWidth: '400px',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
              position: 'relative',
            }}
          >
            {/* Close */}
            <button
              onClick={() => setShowContact(false)}
              style={{
                position: 'absolute', top: '14px', right: '14px',
                background: 'none', border: 'none', cursor: 'pointer',
                color: 'var(--text-dim)', fontSize: '16px', lineHeight: 1,
                fontFamily: 'DM Sans, sans-serif',
              }}
            >
              ✕
            </button>

            {/* Header */}
            <div>
              <h2 style={{ fontFamily: 'Instrument Serif, serif', fontSize: '22px', color: 'var(--text)', marginBottom: '6px' }}>
                Get in touch
              </h2>
              <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.6 }}>
                Questions, feedback, or just want to talk about NoiseGate? We genuinely want to hear from you — especially during beta.
              </p>
            </div>

            {/* Email */}
            <div style={{
              background: 'var(--surface-raised)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '10px 12px',
            }}>
              <span style={{ fontSize: '14px', color: 'var(--text)', fontWeight: 500 }}>
                hunter@teamhat.org
              </span>
              <a
                href="mailto:hunter@teamhat.org"
                style={{
                  fontSize: '12px', color: 'var(--green)',
                  textDecoration: 'none', fontWeight: 500,
                  background: 'var(--green-glow)',
                  border: '1px solid var(--green-dim)',
                  borderRadius: '20px',
                  padding: '4px 12px',
                }}
              >
                Send email →
              </a>
            </div>

            <p style={{ fontSize: '12px', color: 'var(--text-dim)', lineHeight: 1.6 }}>
              We read everything and respond to every message. Your feedback directly shapes what gets built next.
            </p>
          </div>
        </div>
      )}

      {/* Feature request modal */}
      {showFeatureRequest && <FeatureRequestModal onClose={() => setShowFeatureRequest(false)} />}
    </>
  );
}
